import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import VueTables from 'vue-tables-2';
import Spinner from 'vue-simple-spinner';
import DonutPlugin from 'vue-css-donut-chart';
import * as VueGoogleMaps from 'vue2-google-maps';
import 'vue-css-donut-chart/dist/vcdonut.css';
import money from 'v-money';
import { Tabs, Tab } from 'vue-tabs-component';
import Toasted from 'vue-toasted';
import VCalendar from 'v-calendar';

Vue.config.productionTip = false;

Vue.use(VueTables.ClientTable);
Vue.use(DonutPlugin);
Vue.use(money, { precision: 2 });
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBkck6hyz4jQgsPNVnPTATqQ_iLqPFm6zU',
    libraries: 'places'
  }
});
Vue.use(Toasted, {
  position: 'bottom-right',
  duration: 2000,
  keepOnHover: true,
  iconPack: 'fontawesome',
  icon: 'fa-bell',
  theme: 'bubble',
  className: ['toast-bubble'],
  singleton: true
});

Vue.use(VCalendar);

Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
Vue.component('spinner', Spinner);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
